import ConfigProxy      from '../../../tools/ConfigProxy';
import { ApiConnector } from '../connectors/ApiConnector';
import AbstractApiModel from './AbstractApiModel';

export const invoiceConnector = new ApiConnector({
	baseURL: ConfigProxy.getServiceConfig('invoice', 'api_endpoint'),
});

export default class InvoiceApiModel extends AbstractApiModel {
	public static get connector() {
		return invoiceConnector;
	}
}
